import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";


interface CatalogoState {
    status: string;
    error: string;
    catalogoList: any[],
    catalogoListActive: any[],
    catalogo: {
        idCatalogo: number | null;
        nombre: string | null;
        estado: number | null;
    }

}

const initialState: CatalogoState = {
    status: 'idle',
    error: '',
    catalogoList: [],
    catalogoListActive: [],
    catalogo: {
        idCatalogo: null,
        nombre: null,
        estado: null,
    }
}

export const fetchCatalogo = createAsyncThunk('fetchCatalogo', async ({ idsp }: any, { dispatch, getState, rejectWithValue }) => {
    if (idsp !== "" && idsp != null) {
        const { result, message, data } = await getData({ idsp }, getState, dispatch);
        if (result) {
            return { data };
        }
        return rejectWithValue(message);
    }
    return {};
});

export const fetchCatalogoActive = createAsyncThunk('fetchCatalogoActive', async (_: any, { dispatch,getState, rejectWithValue }) => {
    const idsp = 11;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateOpcionCatalogo = createAsyncThunk('modifyCreateOpcionCatalogo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const catalogo = selectCatalogo(state);
    const catalogoAttributes = { ...catalogo }
    const idsp = catalogoAttributes.estado ? 13 : 12;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...catalogoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 5000);
    dispatch(fetchCatalogo({ idsp: catalogoAttributes.idCatalogo }));
    return rejectWithValue(message);
});

export const updateEstadoOpcionCatalogo = createAsyncThunk('updateEstadoOpcionCatalogo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const catalogo = selectCatalogo(state);
    const catalogoAttributes = { ...catalogo }
    catalogoAttributes.estado = Number(!catalogoAttributes.estado);
    const idsp = 14;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...catalogoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 5000);
    dispatch(fetchCatalogo({ idsp: catalogoAttributes.idCatalogo }));
    return rejectWithValue(message);
});


export const catalogoSlice = createSlice({
    name: 'catalogo',
    initialState,
    reducers: {
        setCatalogoList: (state, action) => {
            state.catalogoList = action.payload;
        },
        setCatalogoListActive: (state, action) => {
            state.catalogoListActive = action.payload;
        },
        setCatalogo: (state, action) => {
            state.catalogo = !action.payload ? initialState.catalogo : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchCatalogo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCatalogo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.catalogoList = data ? data : [];

            })
            .addCase(fetchCatalogo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchCatalogoActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCatalogoActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.catalogoListActive = data ? data : [];

            })
            .addCase(fetchCatalogoActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateOpcionCatalogo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateOpcionCatalogo.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(modifyCreateOpcionCatalogo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(updateEstadoOpcionCatalogo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEstadoOpcionCatalogo.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(updateEstadoOpcionCatalogo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectCatalogoList = (state: RootState) => state.catalogo.catalogoList;
export const selectCatalogoListActive = (state: RootState) => state.catalogo.catalogoListActive;
export const selectCatalogo = (state: RootState) => state.catalogo.catalogo;

export const { setCatalogoList, setCatalogoListActive, setCatalogo } = catalogoSlice.actions;

export default catalogoSlice.reducer;